
import { LocalDictionaryFactory } from '../../api/api.module'

import { LoggerService } from '../../common/common.module'

import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

import { ConsumerTypeHelper } from '../consumer-types.helper'
import { ConsumerTypeDetailDirectiveController } from './consumer-types-details.directive.controller'

//#region Asset Imports

import * as TEMPLATE from './consumer-types-details.tpl.html'


//#endregion

// #region Setup

export class ConsumerTypeDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = ['$scope', '$q', '$timeout', 'logger', 'localDictionary', USER_SESSION_SERVICE_NAME, (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        userSession: UserSessionService
    ) => new ConsumerTypeDetailDirectiveController(
        $scope,
        $q,
        $timeout,
        logger,
        localDictionary,
        userSession,
        ConsumerTypeHelper.REFERENCE_TYPE,
        ConsumerTypeHelper.SIMAX_MODULE_NAME
    )]

    template = TEMPLATE
}

// #endregion
